module.exports = {
  "/": {},
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPage"
  },
  "/content": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPage"
  },
  "/operations": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "operationsPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPlusPage"
  },
  "/splash": {
    "success": {
      "default": [
        "SPLASH_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "splashPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPage"
  },
  "/marketing/:tab": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPagePublic"
  },
  "/sales/:tab": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPagePublic"
  },
  "/service/:tab": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePagePublic"
  },
  "/cms/:tab": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPagePublic"
  },
  "/content/:tab": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPagePublic"
  },
  "/operations/:tab": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "operationsPagePublic"
  },
  "/suite/:tab": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePagePublic"
  },
  "/splash/:tab": {
    "success": {
      "default": [
        "SPLASH_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "splashPagePublic"
  },
  "/smart-crm/:tab": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPagePublic"
  },
  "/breeze-intelligence": {
    "success": {
      "default": [
        "BREEZE_INTELLIGENCE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "breezeIntelligencePage"
  },
  "/hubspot-credits": {
    "success": {
      "default": [
        "HUBSPOT_CREDITS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "hubSpotCreditsPage"
  }
};